

































import {Component, Vue} from 'vue-property-decorator';
import {i18n} from "../plugin/i18n";
import ButtonNextPage from '../components/ButtonNextPage.vue';
import LittleArticleCarrousel from '../components/LittleArticleCarrousel.vue';
import {Meta} from '../decorators/decorators';
import ArticleSection from '../components/ArticleSection.vue';
import KeyFigureList from "../components/KeyFigureList.vue";
import Author from "../components/Author.vue";


@Component({
	components: {LittleArticleCarrousel, ButtonNextPage, ArticleSection, Author, KeyFigureList},
})

export default class Sustainable extends Vue {
	figures: any[] = i18n.t('Sustainable.keyFigures') as any;

	@Meta
	myMetaConfig() {
		return {
			title: i18n.t('Sustainable.title')
		}
	}
}
